import { useAuthStore } from '../store/auth.store.js';
import { authApi } from '../api/auth.api.js';

export function useAuth() {
  const {
    account,
    role,
    accessToken,
    tenantSlug,
    availableTenants,
    logout,
    setAccount,
    setRole,
    setTokens,
    setTenantSlug,
    setAvailableTenants,
  } = useAuthStore();

  async function login(email: string, password: string) {
    const res = await authApi.login(email, password);
    const data = res.data;
    setTokens(data.accessToken, data.refreshToken);
    setAccount(data.account);
    setRole(data.role);
    setTenantSlug(data.tenant?.slug ?? null);
    setAvailableTenants(data.availableTenants);
    return { type: data.role ? ('admin' as const) : ('account' as const) };
  }

  async function register(
    email: string,
    password: string,
    firstName: string | undefined,
    lastName: string | undefined,
    phone: string,
    referralCode?: string,
    redirectTo?: string,
  ) {
    const res = await authApi.register(
      email,
      password,
      firstName,
      lastName,
      phone,
      referralCode,
      redirectTo,
    );
    return res.data;
  }

  async function switchTenant(tenantSlug: string) {
    const res = await authApi.switchTenant(tenantSlug);
    setTokens(res.data.accessToken, res.data.refreshToken);
    setAccount(res.data.account);
    setRole(res.data.role);
    setTenantSlug(res.data.tenant?.slug ?? null);
    setAvailableTenants(res.data.availableTenants);
    return res.data.account;
  }

  async function signOut() {
    try {
      await authApi.logout();
    } catch {
      /* ignore */
    }
    logout();
  }

  return {
    account,
    role,
    tenantSlug,
    availableTenants,
    isAuthenticated: !!accessToken,
    isAdmin: !!role,
    isBooker: !!account,
    login,
    register,
    switchTenant,
    signOut,
    setAccount,
    setTenantSlug,
    setTokens,
  };
}
